import React ,{Component } from 'react';
import Dashboard from '../views/dashboard';
import { dashboardActions } from "../../actions";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

class DashboardContainer extends Component {
    constructor(props) {
        super(props);
        this.state={
           
        }        
    }
    componentDidMount(){

        const {dispatch, match} = this.props;
        dispatch(dashboardActions.get());
       
        
    }

   
    
    render() { 

        const {list}=this.props;
       
        return ( 
           <Dashboard model={list && list.Dashboard}></Dashboard>
         );
    }
}

function mapStateToProps(state) {
    const { obj,objs } = state;
    console.log(objs);
   
    //const { queryable } = items;
    return {
        list:objs.item,
        
           
        
    };
} 

export default withRouter(connect(mapStateToProps)(DashboardContainer));